import { IconButton } from "@smartsuite/react-ui/lib/components/buttons/IconButton/IconButton";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import type { Placements } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip.constants";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export interface PaginatorProps {
  recordIndex: number;
  totalRecords: number;
  onPageChange: (page: number) => void;
}

const tooltipPlacements: Placements = ["top"];

export const Paginator: React.FC<PaginatorProps> = ({
  recordIndex,
  totalRecords,
  onPageChange,
}) => {
  const isDisabledPreviousButton = recordIndex <= 0;
  const isDisabledNextButton = recordIndex >= totalRecords - 1;

  return (
    <div className="paginator">
      <Tooltip
        text="Previous Record"
        padding={2}
        placements={tooltipPlacements}
        disabled={isDisabledPreviousButton}
        target={
          <IconButton
            kind="round"
            name="arrow-left-1"
            color={
              isDisabledPreviousButton
                ? GrayColors["G-3"]
                : SolutionColorVariables.sc1
            }
            hoverColor={SolutionColorVariables.sc1}
            backgroundHoverColor={SolutionColorVariables.sc2}
            disabled={isDisabledPreviousButton}
            ariaLabel="Go to previous record"
            className="paginator__button"
            onClick={() => onPageChange(recordIndex - 1)}
          />
        }
      />

      <Tooltip
        text="Next Record"
        padding={2}
        placements={tooltipPlacements}
        disabled={isDisabledNextButton}
        target={
          <IconButton
            kind="round"
            name="arrow-right-1"
            color={
              isDisabledNextButton
                ? GrayColors["G-3"]
                : SolutionColorVariables.sc1
            }
            hoverColor={SolutionColorVariables.sc1}
            backgroundHoverColor={SolutionColorVariables.sc2}
            disabled={isDisabledNextButton}
            ariaLabel="Go to next record"
            className="paginator__button"
            onClick={() => onPageChange(recordIndex + 1)}
          />
        }
      />
    </div>
  );
};
